import { doc, setDoc } from 'firebase/firestore';
import { db } from '@/services';
import type { FontScaleId, LanguageCode, ThemeId } from '@/types';

export interface UserSettingsUpdate {
  theme?: ThemeId;
  language?: LanguageCode;
  fontScale?: FontScaleId;
  /**
   * Only ever set to `false` from the client (clearing the flag once the
   * user has chosen their own new password) — Firestore rules reject any
   * client write that tries to set this back to `true`. Setting it to
   * `true` for someone else is an admin-only operation via
   * `resetUserPassword` (Cloud Function).
   */
  mustChangePassword?: false;
}

/**
 * Self-service update of the caller's own low-risk preferences
 * (theme/language/clearing `mustChangePassword`). Writes directly to
 * Firestore — no Cloud Function involved, since Firestore rules allow a
 * user to update only these specific fields on their own `users/{uid}` doc.
 * Every other `AppUser` field remains immutable to clients and must go
 * through an admin Cloud Function instead.
 */
export const updateUserSettings = async (
  uid: string,
  settings: UserSettingsUpdate,
): Promise<void> => {
  await setDoc(doc(db, 'users', uid), settings, { merge: true });
};
